import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import DocumentElement from "../DocumentView/DocumentElement";

interface Props {
  element: DocumentElementType;
}

/**
 * A callout: an emoji + a stack of child blocks inside a tinted box, for tips /
 * notes. A container — its children are authored on the canvas (the editor host
 * renders the drop zone); this renderer is the read/fill/print view, stacking
 * the child blocks via the element dispatcher.
 */
const PageCallout: React.FC<Props> = ({ element }) => {
  const children = element.elements || [];
  return (
    <div className="flex items-start gap-[12px] rounded-[10px] border border-[#ecebe6] bg-[#f7f6f3] px-[16px] py-[14px]">
      <span aria-hidden className="flex-none select-none text-[18px] leading-[1.5]">
        💡
      </span>
      <div className="min-w-0 flex-1 space-y-1">
        {children.map((child) => (
          <DocumentElement key={child.id} element={child} />
        ))}
      </div>
    </div>
  );
};

export default PageCallout;
